import { render, staticRenderFns } from "./NamespaceItem.vue?vue&type=template&id=157d1112&scoped=true&"
import script from "./NamespaceItem.vue?vue&type=script&lang=js&"
export * from "./NamespaceItem.vue?vue&type=script&lang=js&"
import style0 from "./NamespaceItem.vue?vue&type=style&index=0&id=157d1112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d1112",
  null
  
)

export default component.exports